import axios from 'axios';

const teanaDM = axios.create({
  baseURL: process.env.REACT_APP_DM_HOST,
});

const teanaApi = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
});

const statusData = { type: 'success', status: '200', msg: '' };

export const requestAutoCompleteList = async text => {
  let data = { status: statusData, data: {} };

  try {
  //  const res = await teanaApi.post('/api/supremeCourt/autoCom', { domain: process.env.REACT_APP_DOMAIN_ID, area: text });
      const res = await axios.post('/autocomplete', { domain: process.env.REACT_APP_DOMAIN_ID, area: text });

    data = { ...data, data: res.data };
  } catch (err) {
    data = { ...data, status: { ...statusData, status: '400', msg: e.message } };
  }
  return data;
};

export const requestGuideMap = async req => {
  let getData = { status: statusData, data: {} };

  try {
    const resp = await axios.get('/guideMap');
    getData = { ...getData, data: resp.data };  
   // console.log("requestGuideMap = " + JSON.stringify(getData));

  } catch (e) {
    const statusSet = { ...statusData, status: '400', msg: e.message };
    getData = { ...getData, status: statusSet };
  }
  return getData;
};

export const requestForbiddenAuto = async req => {
  let getData = { status: statusData, data: {} };

  try {
    const resp = await axios.get('/forbiddenAuto');
    getData = { ...getData, data: resp.data };  
    // console.log("forbiddenAuto = " + JSON.stringify(getData));

  } catch (e) {
    const statusSet = { ...statusData, status: '400', msg: e.message };
    getData = { ...getData, status: statusSet };
  }
  return getData;
};

export const requestTermSearch = async req => {
  let getData = { status: statusData, data: {} };

  try {
    const resp = await axios.get('/termSearch');
    getData = { ...getData, data: resp.data };  
    // console.log("requestTermSearch = " + JSON.stringify(getData));

  } catch (e) {
    const statusSet = { ...statusData, status: '400', msg: e.message };
    getData = { ...getData, status: statusSet };
  }
  return getData;
};


export const requestDMPost = async req => {
  let getData = { status: statusData, data: {} };

  // console.log("requestDMPOST = " + JSON.stringify(req.param));
  try {
    const resp = await axios.post('/dialogue', req.param);
    getData = { ...getData, data: resp.data };
    // console.log("getData", getData);
    getData =  makeCustomTextBox(getData);


  } catch (e) {
    const statusSet = { ...statusData, status: '400', msg: e.message };
    getData = { ...getData, status: statusSet };
  }
  return getData;
};

export const requestQuality = async () => {
  let getData = { status: statusData, data: {} };
  const param = {"domain_id": process.env.REACT_APP_DOMAIN_ID, "token": process.env.REACT_APP_TOKEN};
  try {
    const resp = await axios.post('/quality', param);
    getData = { ...getData, data: resp.data };
  } catch (e) {
    const statusSet = { ...statusData, status: '400', type: 'error', msg: e.message };
    getData = { ...getData, status: statusSet };
  }

  return getData;
};

const makeCustomTextBox = (getData) => {
  const combineNoticeData = getData;
  const messageData = combineNoticeData.data?.data?.result?.fulfillment?.messages;
  if(messageData !== undefined && (messageData[0].id === 'textbox_card' || messageData[1].id === 'textbox_card') && messageData.length > 1) {
	const tempItemList = { 
		text : { desc: ''}, 
		id: 'text_card_btn', 
		button: []
	};
	const indexNumberSetting = messageData[0].id === 'textbox_card' ? 0 : 1;  
	const length = messageData.length;
    for(let i=indexNumberSetting + 0; i< messageData.length ;i+=1) {
      for(let j= 0; j< messageData[i].items.length; j+=1) {
        messageData[i].items[j].id = messageData[i].id;
        if(i !==0) {
		if(messageData[i].items[j].id === 'list_btn_title') {
		  tempItemList.text.desc = messageData[i].items[j].text.desc;
		}
		if(messageData[i].items[j].id === 'list_btn') {
		   const { action, label, value } = messageData[i].items[j].button;
		   tempItemList.button.push({action, label, value });
		}
        }
      }
    }
	  if(indexNumberSetting === 0) {
	  messageData[0].items.push(tempItemList);
	  } else {
	  messageData[1].items.push(tempItemList);
	  }
	//  console.log("messageData = " + JSON.stringify(messageData))
	  for(let k=indexNumberSetting + 1; k< length;k +=1) {
		messageData.pop();
	  }
    combineNoticeData.data.data.result.fulfillment.messages = messageData;
  }
  return combineNoticeData;
}


